import React from 'react';
import { Card } from '../UI/Card';
import { Calendar, MapPin, Clock } from 'lucide-react';
import { Button } from '../UI/Button';
export const UpcomingEvents = () => {
  const events = [{
    title: 'Berlin Networking Night',
    date: 'June 15, 2023',
    location: 'Berlin, Germany',
    time: '6:00 PM - 9:00 PM',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1BbFm8kmubumv56AGcAZxq/1755202597061.jpg'
  }, {
    title: 'Lagos Tech Meetup',
    date: 'June 22, 2023',
    location: 'Lagos, Nigeria',
    time: '4:00 PM - 7:00 PM',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uiXQQAf7xCj7Df9afZdc12/five_ladies.jpg'
  }, {
    title: 'São Paulo Creative Session',
    date: 'July 5, 2023',
    location: 'São Paulo, Brazil',
    time: '5:00 PM - 8:00 PM',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kuYFBEnx6pGWYjXhvRTywy/Four_uke.jpg'
  }];
  return <section className="py-16 border-b-2 border-gray-300" data-id="element-584">
      <div className="container mx-auto px-4" data-id="element-585">
        <h2 className="text-3xl font-bold mb-12" data-id="element-586">Upcoming Salons</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-587">
          {events.map((event, index) => <Card key={index} className="flex flex-col" interactive data-id="element-588">
              <div className="relative aspect-[16/9] border-2 border-gray-300 mb-4 overflow-hidden" data-id="element-589">
                <img src={event.image} alt={event.title} className="w-full h-full object-cover" data-id="element-590" />
              </div>
              <h3 className="text-xl font-bold" data-id="element-591">{event.title}</h3>
              <div className="mt-4 space-y-2 flex-grow" data-id="element-592">
                <div className="flex items-center" data-id="element-593">
                  <Calendar size={18} className="mr-2" data-id="element-594" />
                  <span data-id="element-595">{event.date}</span>
                </div>
                <div className="flex items-center" data-id="element-596">
                  <MapPin size={18} className="mr-2" data-id="element-597" />
                  <span data-id="element-598">{event.location}</span>
                </div>
                <div className="flex items-center" data-id="element-599">
                  <Clock size={18} className="mr-2" data-id="element-600" />
                  <span data-id="element-601">{event.time}</span>
                </div>
              </div>
              <div className="mt-6" data-id="element-602">
                <Button variant="outline" className="w-full" data-id="element-603">
                  RSVP
                </Button>
              </div>
            </Card>)}
        </div>
        <div className="mt-12 text-center" data-id="element-604">
          <Button data-id="element-605">View All Events</Button>
        </div>
      </div>
    </section>;
};